import { merge } from 'lodash'
import { create } from 'zustand'
import { createJSONStorage, persist, subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

type State = {
  menuOpen: boolean
  gridLayout: number
  liveroomPanelOpen: boolean
}

type Actions = {
  // eslint-disable-next-line no-unused-vars
  setState: (state?: Partial<State>) => void
}

const initialState: State = {
  menuOpen: false,
  gridLayout: 0, // default state => @/hooks/use-ssr-grid-layout.ts
  liveroomPanelOpen: false
}

const useLayoutStore = create(
  persist(
    subscribeWithSelector(
      immer<State & Actions>((set) => ({
        ...initialState,
        setState: (state) => set((prevState) => merge(prevState, state))
      }))
    ),
    {
      name: 'coloridecora-layout', // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
      partialize: ({ menuOpen, gridLayout }) => ({
        menuOpen,
        gridLayout
      })
    }
  )
)

export { useLayoutStore }
